// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__1QqOx","up":"Reveal_up__xviVW","left":"Reveal_left__XxRBg","right":"Reveal_right__BNiFB","none":"Reveal_none__SMCJl","visible":"Reveal_visible__9FnDp"};